import { useLocation, useNavigate, useOutletContext } from "react-router-dom";

import { NewFoodItem } from "./new-food-item";
import type { LogMealsOutletContext } from "./use-new-food-flow";

export const LogMealsNewFoodRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { initialFoodName, onFoodCreated, onCancel } = useOutletContext<LogMealsOutletContext>();
  const locationState = location.state as { initialName?: string } | null;
  const resolvedInitialName = locationState?.initialName ?? initialFoodName;

  const handleCancel = () => {
    onCancel();
    navigate("..", { replace: true });
  };

  const handleSuccess: Parameters<typeof NewFoodItem>[0]["onSuccess"] = (item) => {
    onFoodCreated(item);
    navigate("..", { replace: true });
  };

  return <NewFoodItem initialName={resolvedInitialName} onCancel={handleCancel} onSuccess={handleSuccess} />;
};
